export default __webpack_public_path__ + "static/10-mouth-watering-destinations-for-unashamed-foodies-pretzel-0c45a5ba61e6c31a10c758a9c743e872.jpg";